import * as React from "react";
import { DocumentManager } from "PDFImporter/Manager/PDFManager/DocumentManager";
import './AddFieldItem.css'

export class AddFieldItem extends React.Component<AddFieldItemProps, AddFieldItemState> {
    static defaultProps: Partial<AddFieldItemProps> = {};

    constructor(props: AddFieldItemProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <div className={'AddFieldItem '+this.props.Id} style={{padding:10,display:'flex',alignItems:'center'}} onClick={()=>this.StartAddition()}>
                <div style={{border:'1px solid #ccc',display:'inline-block'}}>
                    <img src={`${rnImporterVar.RootURL}images/fieldIcons/${this.props.Image}`}/>
                </div>
                <label style={{marginLeft:10,fontSize:15}}>{this.props.Label}</label>
            </div>
        )
    }

    private StartAddition() {
        this.props.DocumentManager.AddFieldManager.StartAddition(this.props.Id);
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AddFieldItemProps {
    DocumentManager:DocumentManager;
    Id:string;
    Image:string;
    Label:string;
}

interface AddFieldItemState {

}

//#endregion "My Region"